import {useQuery} from 'react-apollo'
import {useMutation} from '@apollo/react-hooks'
import gql from 'graphql-tag'
import {CLIENT_PROFILE_QUERY, CLIENT_DATA_QUERY} from '../../../graphql/queries'

const FETCH_CLIENT_ADDRESS_PROPOSAL = gql`
  query($clientId: Int!) {
    addressProposal(clientId: $clientId) {
      country
      zip
      city
      line1
      region
    }
  }
`

const CONFIRM_ADDRESS_PROPOSAL_MUTATION = gql`
  mutation($clientId: Int!) {
    confirmAddressProposal(clientId: $clientId) {
      country
      zip
      city
      line1
      region
    }
  }
`

function useFetchAddressProposal(clientId, {skip = false} = {}) {
  const {loading, data} = useQuery(FETCH_CLIENT_ADDRESS_PROPOSAL, {
    variables: {clientId},
    skip
  })

  const addressProposal = data?.addressProposal || null

  return {
    addressProposal,
    fetching: loading
  }
}


function useConfirmAddressProposal(clientId: number) {
  const [mutation, {loading}] = useMutation(CONFIRM_ADDRESS_PROPOSAL_MUTATION, {
    refetchQueries: [{query: CLIENT_PROFILE_QUERY}, {query: CLIENT_DATA_QUERY}]
  })
  const confirmAddressProposal = () => mutation({variables: {clientId}})

  return {confirmAddressProposal, submitting: loading}
}

export {useFetchAddressProposal, useConfirmAddressProposal}
